import type { UserManager } from "oidc-client-ts";

import { buildOidcSettings, readOidcEnv } from "./oidcConfig";
import { createUserManager } from "./userManager";

let cached: UserManager | null = null;

function isBrowser(): boolean {
  return typeof window !== "undefined";
}

/**
 * Returns the single OIDC UserManager instance for the browser runtime.
 *
 * This is intentionally not React-specific so it can be used by:
 * - `lib/auth/AuthProvider.tsx`
 * - `services/*` (Axios/OpenAPI clients)
 * - streaming fetch adapters that need an access token
 */
export function getOidcUserManager(): UserManager {
  if (!isBrowser()) {
    throw new Error("OIDC UserManager is only available in the browser.");
  }

  if (cached) return cached;

  const oidcEnv = readOidcEnv();
  const settings = buildOidcSettings(oidcEnv, {
    localStorage: window.localStorage,
    sessionStorage: window.sessionStorage,
  });

  cached = createUserManager(settings);
  return cached;
}

